export function authHeader(multipart) {
  const token = localStorage.getItem("token");

  if (!token) {
    return { "Content-Type": "application/json" };
  }

  let scheme = localStorage.getItem("token_type");
  if (!scheme) {
    scheme = token.includes(".") ? "Bearer" : "Token";
  }

  const headers = {
    Authorization: `${scheme} ${token}`,
  };

  if (!multipart) {
    headers["Content-Type"] = "application/json";
  }

  return headers;
}
